var UserProfile = (function () {
  var userData;

  var getUserData = function () {
    // if (!userData) { 
    //   userData = JSON.parse(sessionStorage.getItem("userData"));
    // }
    userData = JSON.parse(atob(sessionStorage.getItem("userData")));
    return userData;
  };

  var setUserData = function (userData) {
    sessionStorage.setItem("userData", btoa(JSON.stringify(userData)));
    userData = JSON.parse(atob(sessionStorage.getItem("userData")));
  };

  return {
    getUserData,
    setUserData
  }
})();

export default UserProfile;